import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import { FaUserMd, FaDna, FaProcedures, FaVenusMars, FaMale, FaVial, FaUserFriends, FaRegClock, FaChartLine, FaHeart, FaStethoscope, FaHospital, FaHandshake, FaLock } from "react-icons/fa";
import Section from "../Section";
import FaqSectionStyle2 from "../Section/FaqSection/FaqSectionStyle2";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import styled from "styled-components";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import WorkingProcess from "../Section/WorkingProcess";
import Spacing from "../Spacing";
import Post from "../Post";
import { Helmet } from "react-helmet";

const faqData = [
  {
    title:
      "What is egg donation and sperm donation, and who can benefit from these services ?",
    content:
      "Egg donation and sperm donation are fertility treatments where eggs or sperm from a donor are used to help individuals and couples achieve pregnancy. These services benefit women with ovarian failure or diminished ovarian reserve, men with severe male factor infertility, individuals carrying genetic disorders they do not want to pass on to their offspring, and same-sex couples or single individuals wanting to have children.",
  },
  {
    title:
      "How are egg and sperm donors selected at Pluro Jabalpur Fertility Centre ?",
    content:
      "At Pluro Jabalpur Fertility Centre, egg and sperm donors are recruited & selected From affliated and registered ART banks, Where They  undergo a rigorous screening process to ensure they are healthy and suitable. This process includes medical screening involving a comprehensive medical and family history evaluation, genetic testing to screen for genetic disorders and chromosomal abnormalities, infectious disease testing for infections such as HIV, Hepatitis B and C, and other sexually transmitted infections, a psychological evaluation to assess the donor’s mental health and emotional well-being, and a lifestyle assessment to ensure the donor leads a healthy lifestyle.",
  },
  {
    title: "What is the process of egg donation and sperm donation ?",
    content:
      "The processes of egg and sperm donation involve several steps. For egg donation: Ovarian Stimulation, where the donor receives hormonal medications to stimulate the ovaries to produce multiple eggs; Monitoring through regular blood tests and ultrasounds to track the development of the eggs; Egg Retrieval, a minor surgical procedure to retrieve mature eggs from the donor’s ovaries; and Fertilization, where the retrieved eggs are fertilized with the recipient’s partner’s sperm or donor sperm. For sperm donation: Sperm Collection, where the donor provides a sperm sample through masturbation; Sperm Analysis and Processing, where the sample is analyzed and processed to concentrate the healthiest sperm; and Cryopreservation, where the sperm sample is frozen and stored until needed for insemination or IVF.",
  },
  {
    title: "What are the success rates of using donor eggs and donor sperm ?",
    content:
      "The success rates of using donor eggs and donor sperm can be higher compared to using the intended parents' eggs and sperm, particularly if there are underlying fertility issues. Success rates vary based on factors such as the recipient’s age and health, but on average: for Egg Donation, success rates range from 50% to 70% per cycle; and for Sperm Donation, success rates vary depending on the method used (IUI or IVF) and other factors, generally ranging from 15% to 30% per cycle for IUI and ranging from 50% to 70% per cycle for IVF.",
  },
  {
    title:
      "Are there any risks or legal considerations involved in egg and sperm donation ?",
    content:
      "Egg and sperm donation are generally safe procedures, but they do involve some risks and legal considerations. Medical risks for egg donors include Ovarian Hyperstimulation Syndrome (OHSS) and complications from the retrieval procedure, while sperm donation has minimal medical risks. Emotional considerations include potential emotional and psychological effects for donors, and counseling is recommended. Legal considerations are governed by strict legal guidelines at Pluro Jabalpur Fertility Centre to protect the rights and privacy of both donors and recipients. Donors typically waive parental rights, and recipients are recognized as the legal parents of any resulting children.",
  },
];

const EggDonation = [
  {
    title: "Initial Consultation and Assessment",
    subTitle:
      "Comprehensive evaluation of both the donor and recipient, including medical history review, physical examination, and fertility testing. Detailed discussion of the egg donation process, potential risks, success rates, and expected outcomes.",
    iconUrl: "/images/home_2/department_icon1.png",
    number: "01",
  },
  {
    title: "Donor Selection",
    subTitle:
      "Selection of an egg donor based on compatibility and medical suitability. Screening for infectious diseases, genetic conditions, and psychological evaluation.",
    iconUrl: "/images/home_2/department_icon2.png",
    number: "02",
  },
  {
    title: "Ovarian Stimulation and Monitoring",
    subTitle:
      "Administration of fertility medications to the donor to stimulate the ovaries to produce multiple eggs. Regular monitoring through blood tests and ultrasounds to track the development of ovarian follicles.",
    iconUrl: "/images/home_2/department_icon3.png",
    number: "03",
  },
  {
    title: "Egg Retrieval (Oocyte Retrieval)",
    subTitle:
      "A minor surgical procedure performed under sedation to collect mature eggs from the donor’s ovaries. Use of a thin needle guided by ultrasound to aspirate the eggs from the ovarian follicles.",
    iconUrl: "/images/home_2/department_icon25.png",
    number: "04",
  },
  {
    title: "Fertilization and Embryo Transfer",
    subTitle:
      "Eggs are fertilized with the recipient’s partner’s sperm or donor sperm in the laboratory using conventional insemination or intracytoplasmic sperm injection (ICSI). The resulting embryos are cultured and monitored for several days before being transferred into the recipient’s uterus.",
    iconUrl: "/images/home_2/department_icon7.png",
    number: "05",
  },
];

const SpermDonation = [
  {
    title: "Initial Consultation and Assessment",
    subTitle:
      "Comprehensive evaluation of the donor and recipient, including medical history review, physical examination, and fertility testing. Detailed discussion of the sperm donation process, potential risks, success rates, and expected outcomes.",
    iconUrl: "/images/home_2/department_icon1.png",
    number: "01",
  },
  {
    title: "Donor Selection",
    subTitle:
      "Selection of a sperm donor based on compatibility and medical suitability. Screening for infectious diseases, genetic conditions, and psychological evaluation.",
    iconUrl: "/images/home_2/department_icon2.png",
    number: "02",
  },
  {
    title: "Semen Collection and Preparation",
    subTitle:
      "Collection of a semen sample from the donor. Special preparation of the semen in the laboratory to concentrate and select the healthiest, most motile sperm.",
    iconUrl: "/images/home_2/departmentLap4.png",
    number: "03",
  },
  {
    title: "Fertilization and Embryo Transfer",
    subTitle:
      "Sperm is used to fertilize the recipient’s eggs through IVF or ICSI. The resulting embryos are cultured and monitored for several days before being transferred into the recipient’s uterus.",
    iconUrl: "/images/home_2/department_icon7.png",
    number: "04",
  },
];
const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },
];

export default function EggOrSpermDonation() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs_active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.cs_reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Egg & Sperm Donation Program – A Gift of Life</title>
        <meta name="description" content="Helping couples conceive through anonymous egg or sperm donation, ensuring safety, compatibility, and emotional support." />
        <meta name="keywords" content="egg donation, sperm donation, donor program, fertility donation services" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/Egg-Or-Sperm-Donation" />
      </Helmet>
      <Container className="cs_iui_new_wrap">
        <BannerSectionStyle3
          bgUrl="/images/Egg-Or-Sperm-Donation.jpeg"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="Egg Donation / Sperm Donation"
        />

        {/* Intro Section */ }
        <div className="cs_donor_intro_section cs_reveal">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                <span className="cs_donor_badge">Jabalpur Fertility Centre</span>
                <h1 className="cs_donor_title">Advanced Donor Programs</h1>
                <div className="cs_donor_accent_line"></div>
              </div>
              <div className="col-lg-7">
                <div className="cs_donor_desc_card">
                  <p>
                    Egg donation and sperm donation are invaluable options for couples struggling with infertility or genetic issues that prevent them from conceiving naturally. At <span style={ { color: '#c77842', fontWeight: '700' } }>Pluro Jabalpur Fertility Centre</span>, recognized as the Best Fertility Clinic in Jabalpur, we offer comprehensive and compassionate donor programs under the expert care of Dr. Archana Shrivastava, the Best IVF Doctor in Jabalpur. Our goal is to provide the best possible solutions to help you achieve your dream of parenthood.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Luxury Egg Donation Section */ }
        <div className="cs_luxury_section" id="egg-donation">
          <div className="organic-bg"></div>
          <div className="container relative z-10">
            <div className="cs_luxury_hero cs_reveal">
              <div className="cs_lh_content">
                <h3>What is Egg Donation?</h3>
                <p>Egg donation involves a woman (the donor) providing her eggs to another woman (the recipient) to help her conceive. This option is often recommended for women who cannot produce viable eggs due to various reasons, including premature ovarian failure, advanced age, or genetic conditions.</p>
              </div>
              <div className="cs_lh_image_wrap">
                <img src="/images/about/banner_img.png" alt="IVF Laboratory" style={ { objectPosition: 'top center' } } />
              </div>
            </div>

            <div className="text-center mb-5 cs_reveal">
              <h2 className="cs_fs_40 cs_medium" style={ { marginTop: '60px' } }>When is Egg Donation Recommended?</h2>
            </div>

            <div className="cs_luxury_three_grid">
              <div className="cs_premium_service_card theme_orange cs_reveal cs_grid_item_span_2">
                <span className="cs_psc_number">01.</span>
                <h4>Premature Ovarian Failure</h4>
                <p>Early menopause or loss of normal ovarian function before the age of 40.</p>
              </div>

              <div className="cs_premium_service_card theme_orange cs_reveal cs_grid_item_span_2">
                <span className="cs_psc_number">02.</span>
                <h4>Advanced Maternal Age</h4>
                <p>Women of advanced reproductive age whose eggs may not be viable for conception.</p>
              </div>

              <div className="cs_premium_service_card theme_orange cs_reveal cs_grid_item_span_2">
                <span className="cs_psc_number">03.</span>
                <h4>Genetic Disorders</h4>
                <p>Risk of passing on genetic diseases or conditions.</p>
              </div>

              <div className="cs_premium_service_card theme_orange cs_reveal cs_row_2_center_item_1">
                <span className="cs_psc_number">04.</span>
                <h4>Previous IVF Failures</h4>
                <p>Multiple failed IVF attempts due to poor egg quality.</p>
              </div>

              <div className="cs_premium_service_card theme_orange cs_reveal cs_row_2_center_item_2">
                <span className="cs_psc_number">05.</span>
                <h4>Absence of Ovaries</h4>
                <p>Due to surgery, congenital absence, or medical treatments.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Sperm Donation Section */ }
        <div className="cs_luxury_section" id="sperm-donation">
          <div className="container relative z-10">
            <div className="cs_luxury_hero reverse cs_reveal">
              <div className="cs_lh_content">
                <h3>What is Sperm Donation?</h3>
                <p>Sperm donation involves a man (the donor) providing his sperm to assist a couple or individual in achieving pregnancy. This option is often recommended for men who have infertility issues or for single women and same-sex couples who require donor sperm to conceive.</p>
              </div>
              <div className="cs_lh_image_wrap">
                <img src="/images/about/ICSI.jpeg" alt="Sperm Analysis" style={ { objectPosition: 'top center' } } />
              </div>
            </div>

            <div className="text-center mb-5 cs_reveal">
              <h2 className="cs_fs_40 cs_medium" style={ { marginTop: '60px' } }>When is Sperm Donation Recommended?</h2>
            </div>

            <div className="cs_luxury_tight_grid">
              <div className="cs_premium_service_card theme_purple cs_reveal">
                <span className="cs_psc_number">01.</span>
                <h4>Male Factor Infertility</h4>
                <p>Severe low sperm count, poor motility, or abnormal sperm morphology.</p>
              </div>

              <div className="cs_premium_service_card theme_purple cs_reveal">
                <span className="cs_psc_number">02.</span>
                <h4>Genetic Disorders</h4>
                <p>Risk of passing on genetic diseases or conditions.</p>
              </div>

              <div className="cs_premium_service_card theme_purple cs_reveal">
                <span className="cs_psc_number">03.</span>
                <h4>Failed Fertilization</h4>
                <p>Multiple failed attempts at fertilization using partner's sperm.</p>
              </div>

              <div className="cs_premium_service_card theme_purple cs_reveal">
                <span className="cs_psc_number">04.</span>
                <h4>Single / Same-Sex Couples</h4>
                <p>Women who require donor sperm to conceive.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Working Process Sections */ }
        <Section topMd={ 80 } topLg={ 60 } topXl={ 40 }>
          <WorkingProcess
            sectionTitle="Egg Donation Procedure"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ EggDonation }
          />
        </Section>
        <Section topMd={ 80 } topLg={ 60 } topXl={ 40 }>
          <WorkingProcess
            sectionTitle="Sperm Donation Procedure"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ SpermDonation }
          />
        </Section>

        {/* Benefits Section */ }
        <Section topMd={ 120 } topLg={ 100 } topXl={ 80 }>
          <div className="container cs_reveal">
            <h2 className="text-center cs_fs_40 cs_medium mb-5">Benefits of Egg and Sperm Donation</h2>
            <div className="row cs_gap_y_40 justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="cs_benefit_card_luxury theme_orange h-100">
                  <div className="cs_bcl_icon_wrap">
                    <FaChartLine />
                  </div>
                  <h3>Increased Chances of Conception</h3>
                  <p>Donated eggs and sperm often come from young, healthy individuals, increasing the likelihood of successful fertilization and pregnancy.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="cs_benefit_card_luxury theme_purple h-100">
                  <div className="cs_bcl_icon_wrap">
                    <FaDna />
                  </div>
                  <h3>Genetic Screening</h3>
                  <p>Donors undergo thorough genetic screening to minimize the risk of hereditary diseases.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="cs_benefit_card_luxury theme_orange h-100">
                  <div className="cs_bcl_icon_wrap">
                    <FaHeart />
                  </div>
                  <h3>Enabling Parenthood</h3>
                  <p>Provides an opportunity for individuals and couples with severe infertility issues to experience the joy of parenthood.</p>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Why Choose Us Section */ }
        <Section topMd={ 120 } topLg={ 100 } topXl={ 80 } bottomMd={ 80 } bottomLg={ 60 } bottomXl={ 40 }>
          <div className="container cs_reveal">
            <div className="cs_premium_why_choose">
              <div className="cs_premium_section_header">
                <h2>Why Choose Pluro Jabalpur Fertility Centre for Donor Programs ?</h2>
                <p>We tailor our donor programs to meet the unique needs of each couple or individual, ensuring the best possible outcomes.</p>
              </div>

              <div className="row cs_gap_y_40 justify-content-center" style={ { display: 'flex', flexWrap: 'wrap' } }>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaUserMd style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>Expertise and Experience</h3>
                    <p>Led by Dr. Archana Shrivastava, our team has extensive experience in managing successful egg and sperm donation programs.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaHandshake style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>Personalized Care</h3>
                    <p>We tailor our donor programs to meet the unique needs of each couple or individual, ensuring the best possible outcomes.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaHospital style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>Comprehensive & State-of-the-Art</h3>
                    <p>From initial consultation to advanced treatments like IVF and donor programs, our clinic is equipped with the latest technology to provide top-notch fertility care.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaLock style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>Confidential & Compassionate</h3>
                    <p>We prioritize your comfort, privacy, and well-being, offering compassionate support throughout your fertility journey.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* FAQ Section */ }
        <Section topMd={ 40 } topLg={ 20 } topXl={ 0 }>
          <div className="cs_iui_faq_wrapper cs_reveal">
            <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
          </div>
        </Section>



        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container cs_reveal">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { relatedBlog?.map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>
      </Container>
    </>
  );
}

const Container = styled.div`
  .margin {
    margin-left: 25px;
  }
  .heading{
    font-size: 32px;
     @media (max-width: 991px) {
      font-size: 28px;
    }
  }
`;
